import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allAudits: [],
};

const auditSlice = createSlice({
  name: 'setGoals',
  initialState,
  reducers: {
    saveAllAudits(state, action) {
      state.allAudits = action.payload;
    },
  },
});

export const { saveAllAudits } = auditSlice.actions;

export default auditSlice.reducer;
